import $ from 'jquery';
import Parsley from 'parsleyjs';

import 'parsleyjs/dist/i18n/nl';

var parsleyConfig = {
    errorClass: 'is-error',
    excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], :hidden',
    successClass: 'is-success'
};

Parsley.addMessages('nl', {
    mincheck: 'Selecteer tenminste %s optie(s).',
    maxcheck: 'Selecteer maximaal %s optie(s).',
    check: 'Selecteer tussen %s en %s optie(s).'
}).setLocale(document.documentElement.lang);

Parsley.addValidator('maxNumberOfFiles', {
    validateString: function(_value, maxNumberOfFiles, parsleyInstance) {
        if (!window.FormData) {
            return true;
        }

        const files = parsleyInstance.$element[0].files;

        return files.length <= maxNumberOfFiles;
    },
    requirementType: 'integer',
    messages: {
        nl: 'Selecteer maximaal %s bestand(en).'
    }
});

$('form:not([novalidate])').parsley(parsleyConfig);
